import emily from "../../POS/assets/images/Logos/Emily.jpg"
import Harper from "../../POS/assets/images/Logos/Harper.jpg"
import Jacob from "../../POS/assets/images/Logos/Jacob.jpg"
import Benjamin from "../../POS/assets/images/Logos/Benjamin.jpg"
import Lucas from "../../POS/assets/images/Logos/Lucas.jpg"

export const Reviews = [
    {
        Description: "Exceptional service, delectable dishes, and a charming atmosphere—this restaurant has it all! Each visit leaves me eagerly anticipating the next culinary adventure.        ",
        ArtistName: "Emily",
        Image: emily,
    },
    {
        Description: "Incredible flavors, impeccable presentation, and a welcoming ambiance—this restaurant exceeded all my expectations. A true gem in the dining scene!",
        ArtistName: "Harper",
        Image: Harper,
    },
    {
        Description: "From the moment I walked in, I knew I was in for a treat. Every dish was thoughtfully crafted, bursting with flavor and creativity. I left feeling thoroughly satisfied and already planning my return",
        ArtistName: "Jacob",
        Image: Jacob,
    },
    {
        Description: "A culinary journey like no other! This restaurant combines innovative cuisine with top-notch service, resulting in an unforgettable dining experience. Can't wait to return for another round of gastronomic delight!",
        ArtistName: "Benjamin",
        Image: Benjamin,
    },
    {
        Description: "Absolutely blown away by the flavors and presentation at this restaurant! From the first bite to the last, every dish was a masterpiece. A definite must-visit for anyone seeking an unforgettable dining experience.",
        ArtistName: "Lucas ",
        Image: Lucas,
    }
    // ,
    // {
    //     Description: "
    //     ",
    //     ArtistName: "Shoaib ",
    //     Details: "Product designer",
    // },
    // {
    //     Description: "
    //     ",
    //     ArtistName: "Kamran ",
    //     Details: "Product designer",
    // }
];